// Enumeration for button types
export enum ButtonType {
  primary = 'primary',
  secondary = 'secondary'
}
